
        var result = require("!!../../_css-loader@1.0.1@css-loader/index.js!../../_resolve-url-loader@3.1.0@resolve-url-loader/index.js!../../_sass-loader@7.1.0@sass-loader/lib/loader.js??ref--4-3!./mdc-layout-grid.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    